import { MouseEvent, useCallback, useRef, useState } from 'react'
import classNames from 'classnames'
import { PlusIcon } from '../../icons'
import ShopTheLookDrawer, { ShopTheLookProduct } from '../../shop-the-look-drawer/components/ShopTheLookDrawer'

type Props = {
  mount: HTMLElement
}

const parseProducts = (raw: string | undefined): ShopTheLookProduct[] => {
  try {
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (err) {
    console.error('Shop The Look: could not parse image products', err)
    return []
  }
}

/* Overlay on one look image: clicking the image or toggle opens and closes the product drawer. */
const ShopTheLookImageDrawer = ({ mount }: Props) => {
  const products = parseProducts(mount.dataset.products)

  const [isOpen, setIsOpen] = useState(false)
  const toggleRef = useRef<HTMLButtonElement>(null)

  /* Keep focus on the toggle, which stays in place as the drawer closes (e.g. on Escape). */
  const onClose = useCallback(() => {
    setIsOpen(false)
    toggleRef.current?.focus()
  }, [])

  if (!products.length) return null

  const onOverlayClick = (event: MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement).closest('.ShopTheLookDrawer')) return

    if (isOpen) {
      onClose()
    } else {
      setIsOpen(true)
    }
  }

  const onToggleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()

    if (isOpen) {
      onClose()
    } else {
      setIsOpen(true)
    }
  }

  return (
    <div className={classNames('ShopTheLookSection__Overlay', isOpen && 'is-open')} onClick={onOverlayClick}>
      <ShopTheLookDrawer isOpen={isOpen} products={products} onClose={onClose} showClose={false} />

      <button
        ref={toggleRef}
        type="button"
        className="ShopTheLookSection__PlusIcon"
        aria-expanded={isOpen}
        aria-label={isOpen ? 'Close shop the look' : 'Open shop the look'}
        onClick={onToggleClick}
      >
        <PlusIcon />
      </button>
    </div>
  )
}

export default ShopTheLookImageDrawer
